import decryptAES256GCM from "./decryptAES";

/**
 * Decrypt user data from localStorage
 * @param {Object} encryptedUserData - User data with encrypted fields
 * @returns {Object} User data with decrypted force_password_change and force_last_change_password
 */
const decryptUserData = (encryptedUserData) => {
  if (!encryptedUserData) {
    return null;
  }

  const forceKey = process.env.VUE_APP_FORCE_SECRET || '';
  const decryptedUserData = { ...encryptedUserData };

  // Decrypt force_password_change
  if (decryptedUserData.force_password_change) {
    try {
      const decryptedValue = decryptAES256GCM(decryptedUserData.force_password_change, forceKey);
      decryptedUserData.force_password_change = decryptedValue === 'true';
    } catch (error) {
      decryptedUserData.force_password_change = false;
    }
  }

  // Decrypt force_last_change_password
  if (decryptedUserData.force_last_change_password) {
    try {
      const decryptedValue = decryptAES256GCM(decryptedUserData.force_last_change_password, forceKey);
      decryptedUserData.force_last_change_password = parseInt(decryptedValue, 10) || 0;
    } catch (error) {
      decryptedUserData.force_last_change_password = 0;
    }
  }

  return decryptedUserData;
};

export default decryptUserData;